import { Component, OnInit, ViewChild } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { GridModule, CommandClickEventArgs, ToolbarItems } from '@syncfusion/ej2-angular-grids';
import { ToolbarModule } from '@syncfusion/ej2-angular-navigations';
import { GridBaseComponent } from 'src/app/base/shared/grid-base/grid-base.component';
import { SearchFieldComponent } from 'src/app/base/shared/search-field/search-field.component';
import { TitleBarComponent } from 'src/app/base/shared/title-bar/title-bar.component';
import { ParkingRangerAssignmentAdministrationService } from './parking-ranger-assignment-administration.service';
import { DataManager } from '@syncfusion/ej2-data';
import { AvpCustomAdaptor } from 'src/app/base/shared/syncfusion/avp-custom-adaptor';
import { SpinnerService } from 'src/app/base/spinner/spinner.service';
import { SfCommandButtonType } from 'src/app/base/models/syncfusion-data';
import { ParkingRangerAssignmentEditDialogComponent } from './parking-ranger-assignment-edit-dialog/parking-ranger-assignment-edit-dialog.component';

@Component({
  selector: 'app-parking-ranger-assignment-administration',
  templateUrl: './parking-ranger-assignment-administration.component.html',
  styleUrls: ['./parking-ranger-assignment-administration.component.scss'],
  imports: [TitleBarComponent, SearchFieldComponent, GridModule, ToolbarModule, TranslateModule, ParkingRangerAssignmentEditDialogComponent],
  providers: [ParkingRangerAssignmentAdministrationService],
})
export class ParkingRangerAssignmentAdministrationComponent extends GridBaseComponent implements OnInit {
  @ViewChild(ParkingRangerAssignmentEditDialogComponent) public editDialog: ParkingRangerAssignmentEditDialogComponent;

  public zonePathFieldName = this.assignmentService.extendedZonePathFieldName;

  public toolbar: ToolbarItems[] | object = ['ColumnChooser'];

  public override gridCommands = [
        {
          type: SfCommandButtonType.Edit,
          buttonOption:
          {
            cssClass: 'icon-btn',
            iconCss: 'icon-edit e-icons'
          }
        },
        {
          type: SfCommandButtonType.Delete,
          buttonOption:
          {
            cssClass: 'icon-btn',
            iconCss: 'icon-trash-can e-icons e-danger'
          }
        }];

  public override onAdd() {
    this.editDialog.openDialog('add');
  }

  public onBulkDelete() {
    this.editDialog.openDialog('bulkDelete');
  }

  public onEdit(rowData: any) {
    this.editDialog.openDialog('edit', rowData);
  }

  public commandClicked(args: CommandClickEventArgs) {
    if ((args.commandColumn as any).type === SfCommandButtonType.Edit) {
      args.cancel = true;
      this.onEdit(args.rowData);
    }
  }

  public onRecordDoubleClick(args: any) {
    this.onEdit(args.rowData);
  }

  constructor(translateService: TranslateService, private assignmentService: ParkingRangerAssignmentAdministrationService, private spinnerService: SpinnerService) {
    super(null, translateService, assignmentService);
  }

  ngOnInit() {
    this.data = new DataManager({
      adaptor: new AvpCustomAdaptor(this.assignmentService, this.spinnerService),
    });
    this.searchOptions = {fields: ['user.userName', 'client.name', 'zone.name']};
    this.editSettings.allowEditing = false;
  }

  public onRefreshData() {
    this.grid.refresh();
  }

  protected override initializeEditForm(data: any): void {
    throw new Error('Method not implemented.');
  }

  protected override getEditDialogTitleParams(rowData: any) {
    throw new Error('Method not implemented.');
  }

}
